import Q15_1 from './Q15_1';

export default Q15_1;
